import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
  standalone: false,
})
export class AboutUsComponent implements OnInit {
  @Input() school: any = {};
  combinedVisionMission: string =
    'Our mission is to empower students with the knowledge, skills, and values needed to thrive in a changing world. We envision a community where every learner is encouraged to explore, innovate, and contribute positively to society.';
  ngOnInit(): void {
    this.combineVisionAndMission();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['school'] && changes['school'].currentValue) {
      this.combineVisionAndMission();
    }
  }

  combineVisionAndMission(): void {
    const vision = this.school?.vision || '';
    const mission = this.school?.mission || '';
    this.combinedVisionMission = `${mission}  ${vision}`.trim();
  }
}
